export const AccordionItem = ({ num, title, body, open, onToggle, testId }) => (
  <div className="border-b border-[#404653]/40">
    <button
      type="button"
      onClick={onToggle}
      data-testid={testId}
      className="w-full flex items-center gap-5 sm:gap-7 py-6 text-left group"
    >
      <span className="font-mono-strict text-[#0162CA] text-sm shrink-0">{num}</span>
      <span className="flex-1 font-bold uppercase tracking-wide text-sm md:text-base group-hover:text-[#0162CA] transition-colors duration-200">
        {title}
      </span>
      <span className="text-[#0162CA] text-xl font-light shrink-0">{open ? "−" : "+"}</span>
    </button>
    <div
      className="overflow-hidden transition-[max-height,opacity] duration-500 ease-in-out"
      style={{ maxHeight: open ? 320 : 0, opacity: open ? 1 : 0 }}
    >
      <p className="pb-7 pl-10 sm:pl-14 pr-4 text-white/55 text-sm leading-[1.8] max-w-3xl">{body}</p>
    </div>
  </div>
);
